import React from 'react';
import PropTypes from 'prop-types';

function DividingLine({ color = `#383838`, style }) {
  return <div style={{ borderTop: `1px solid ${color}`, ...style }} />
}

DividingLine.propTypes = {
  color: PropTypes.string,
  style: PropTypes.object
}

export default DividingLine;
